export const reportPeriod: Base.KeyLabelModel[] = [
  {
    key: 'DAILY',
    label: 'Daily'
  },
  {
    key: 'WEEKLY',
    label: 'Weekly'
  },
  {
    key: 'BIWEEKLY',
    label: 'BiWeekly'
  },
  {
    key: 'MONTHLY',
    label: 'Monthly'
  }
];

